import axiosInstance from '../axiosInstance';

export const sitesApi = {
    post: (path, params, cancelToken) =>
        axiosInstance
            .post(`/Site${path}`, params, {
                cancelToken: cancelToken?.token
            })
            .then((res) => {
                if (res?.data?.error) throw res.data;
                return res?.data;
            })
            .catch((err) => {
                throw err.error ? err : err?.response?.data;
            }),
    get: (path, params, cancelToken) =>
        axiosInstance
            .get(`/Site${path}`, params, {
                cancelToken: cancelToken?.token
            })
            .then((res) => {
                if (res?.data?.error) throw res.data;
                return res?.data;
            })
            .catch((err) => {
                throw err.error ? err : err?.response?.data;
            })
};

export const saveSite = async (params) => sitesApi.post('/SAVE', params);

export const getAvatar = async (params) => sitesApi.post('/getavatar', params);

export const removeAvatar = async (params) => sitesApi.post('/removeavatar', params);

export const getSite = async (params) => sitesApi.get('/GetSite', { params });

export const getPublicSites = async () => axiosInstance.get('/PublicSites/GetSites').then((res) => res?.data);

export const getPublicSite = async (params) => axiosInstance.get('/PublicSites/GetSite', { params }).then((res) => res?.data);

export const getPublicSiteAvatar = async (params) => axiosInstance.get('/PublicSites/GetAvatar', { params }).then((res) => res?.data);
